var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.company && _vm.landingpageSlugs)?_c('v-select',{ref:"landingpageSlug",staticClass:"mt-2",attrs:{"value":_vm.value,"outlined":"","label":_vm.$t('labels.acquisition-booster.topic-selection'),"validate-on-blur":"","items":_vm.landingpageSlugs,"item-value":"slug","item-text":"name","dense":"","required":""},on:{"change":_vm.onChange}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }